import React from 'react';
import cx from 'classnames';
import Checkbox, { INDETERMINATE } from 'lib/Checkbox';
import { UploadedFileItemProps } from './FrameListPanel.types';
import { calculateFileInclusionState, isFrameExcludedFromFile } from './FrameListPanel.utils';

export const UploadedFileItem: React.FC<UploadedFileItemProps> = ({
  file,
  uploadedListOfFiles,
  openCategories,
  onToggleCategory,
  handleFileToggle,
  handleFrameToggleInFile,
}) => {
  const { fileFrames, isFileIncluded, allFramesIncluded, someFramesIncluded } = calculateFileInclusionState(file);
  const isExpanded = openCategories.includes(file.name);

  const getFileSelectionState = (): boolean | typeof INDETERMINATE => {
    if (allFramesIncluded) return true;
    if (someFramesIncluded) return INDETERMINATE;

    return false;
  };

  return (
    <div key={file.name}>
      <div className="px-4 py-2 hover:bg-neutral-50 flex items-center gap-2">
        <button
          type="button"
          onClick={() => onToggleCategory(file.name)}
          className="flex-shrink-0 text-neutral-700 hover:text-neutral-900"
        >
          <svg
            className={cx('w-4 h-4 transform transition-transform', { 'rotate-90': isExpanded })}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div className="flex-1 min-w-0">
          <Checkbox
            value={file.name}
            label={file.name}
            isSelected={getFileSelectionState()}
            onChange={() => handleFileToggle(file, allFramesIncluded)}
          />
        </div>
      </div>
      {isExpanded &&
        fileFrames.map((frameContent) => {
          const isExcluded = isFrameExcludedFromFile(file.name, frameContent.code, uploadedListOfFiles);
          const isFrameIncluded = isFileIncluded && !isExcluded;

          return (
            <div key={`${frameContent.code}-${file.name}`} className="pl-10 pr-4 py-2 hover:bg-neutral-50">
              <Checkbox
                value={frameContent.code}
                label={frameContent.code}
                isSelected={isFrameIncluded}
                onChange={() => handleFrameToggleInFile(file.name, frameContent.code, isExcluded)}
              />
            </div>
          );
        })}
    </div>
  );
};
